<template>
  <div class="container">
    <Header></Header>

    <div class="banner">
      <img class="banner-bg" src="../assets/images/mainpage-hero-image@2x.png" alt />
      <div class="banner-bottom">
        <h1 v-text="$t('msg.bannerTitle')"></h1>
        <img class="banner-card" src="../assets/images/generic-card@2x.png" alt />
      </div>
    </div>

    <div class="buy-box clearfix">
      <div class="buy-box-left">
        <div class="buy-box-l">
          <h2 v-text="$t('msg.buyTitle')"></h2>
          <ul>
            <li class="clearfix">
              <span>·</span>
              <p v-text="$t('msg.buySubTitle1')"></p>
            </li>
            <li class="clearfix">
              <span>·</span>
              <p v-text="$t('msg.buySubTitle2')"></p>
            </li>
          </ul>
        </div>
        <div class="buy-box-r">
          <span class="currency" v-text="currency"></span>
          <span class="price" v-text="totalPrice"></span>
          <span class="per" v-text="$t('msg.perVisit')"></span>
        </div>
      </div>

      <div class="buy-box-right">
        <div class="buy-box-l">
          <span class="minus" @click="decrement">
            <img src="../assets/images/btn-minus@2x.png" alt />
          </span>
          <span class="number" v-text="count"></span>
          <span class="plus" @click="increment">
            <img src="../assets/images/btn-plus@2x.png" alt />
          </span>
        </div>
        <div class="buy-box-r" v-text="$t('msg.buyBtn')" @click="buy"></div>
      </div>
    </div>

    <div style="height: 1px;width: 100%;background-color: #ddd;"></div>
    <div class="lounges-box">
      <h2 class="box-title" v-text="$t('msg.loungeTitle')"></h2>
      <ul class="lounges-list clearfix">
        <li v-for="item in loungeList" :key="item.id">
          <router-link
            tag="a"
            :to="{path:'/terminal', query:{airportCode: item.airportCode, airportName: item.airportName, airportCountry: item.country, airportCity: item.city, iataCode: item.iataCode}}"
          >
            <div class="lounge-pic clearfix">
              <img
                :src="item.imgUrl.indexOf('null') != -1 ? 'http://image.dragonpass.com.cn/uploadFile/images/HIS/default-lounge%402x.png?w=487&h=292' : item.imgUrl"
                alt
              />
            </div>
            <div class="lounge-msg">
              <h2 class="lounge-name" v-text="item.name"></h2>
              <div class="lounge-location">
                <img src="../assets/images/icon-location@2x.png" alt />
                <div>
                  <p v-text="item.airportName"></p>
                  <p v-text="item.country"></p>
                </div>
              </div>
            </div>
          </router-link>
        </li>
      </ul>
      <div class="lounge-btn">
        <router-link to="/airport" v-text="$t('msg.loungeBtn')"></router-link>
      </div>
    </div>

    <div style="height: 1px;width: 100%;background-color: #ddd;"></div>
    <div class="step-box">
      <h2 class="box-title" v-text="$t('msg.stepTitle')"></h2>
      <ul class="step-list clearfix">
        <li>
          <div class="step-list-title">
            <p v-text="$t('msg.step1Title')"></p>
            <p v-text="$t('msg.step1SubTitle')"></p>
          </div>
          <img class="step-pic" src="../assets/images/icon-step1@2x.png" alt />
          <p class="step-intr" v-text="$t('msg.step1Des')"></p>
          <img class="arrow-right" src="../assets/images/arrow-step123@2x.png" />
          <img class="arrow-down" src="../assets/images/arrow-country-code@2x.png" />
        </li>
        <li>
          <div class="step-list-title">
            <p v-text="$t('msg.step2Title')"></p>
            <p v-text="$t('msg.step2SubTitle')"></p>
          </div>
          <img class="step-pic" src="../assets/images/icon-step2@2x.png" alt />
          <p class="step-intr" v-text="$t('msg.step2Des')"></p>
          <img class="arrow-right" src="../assets/images/arrow-step123@2x.png" />
          <img class="arrow-down" src="../assets/images/arrow-country-code@2x.png" />
        </li>
        <li>
          <div class="step-list-title">
            <p v-text="$t('msg.step3Title')"></p>
            <p v-text="$t('msg.step3SubTitle')"></p>
          </div>
          <img class="step-pic" src="../assets/images/icon-step3@2x.png" alt />
          <p class="step-intr" v-text="$t('msg.step3Des')"></p>
        </li>
      </ul>
    </div>

    <div style="height: 1px;width: 100%;background-color: #ddd;"></div>
    <div class="faqs-box">
      <h2 class="box-title" v-text="$t('msg.faqsTitle')"></h2>
      <ul class="faqs-list">
        <li v-for="(item, index) in faqList" :key="index">
          <p class="q">{{item.Q}}</p>
          <p class="a">{{item.Ans}}</p>
        </li>
      </ul>
    </div>

    <div style="height: 1px;width: 100%;background-color: #ddd;"></div>
    <div class="terms-box">
      <h2 class="box-title">
        <span v-text="$t('msg.term')"></span> &
        <span v-text="$t('msg.condition')"></span>
      </h2>
      <ul class="terms-list">
        <li v-for="(item, index) in termList" :key="index">{{index+1}}. {{item}}</li>
      </ul>
      <div @click="ShowAll" class="show-more">
        <span v-text="$t('msg.readMore')" v-show="!isShowAll"></span>
        <span v-text="$t('msg.readLess')" v-show="isShowAll"></span>
        <img :class="{ active: isActive }" src="../assets/images/arrow-readmore@2x.png" alt />
      </div>
    </div>

    <Footer></Footer>

    <div class="animation" :class="{inClass:fadeIn, outClass:fadeOut}" v-show="isShow">
      <div class="animation-inner clearfix">
        <img class="close-btn" @click="hide" src="../assets/images/btn-close@2x.png" alt />
        <div class="tip" v-text="$t('msg.tipTitle')"></div>
        <div class="btns">
          <a
            class="readMore-btn"
            href="https://en.dragonpass.com.cn/info/privacypolicy"
            target="_blank"
            v-text="$t('msg.tipMoreBtn')"
          ></a>
          <a class="accept-btn" href="javascript:;" v-text="$t('msg.tipAcceptBtn')" @click="hide"></a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

import { mapState } from "vuex";

export default {
  name: "home",
  data: function() {
    return {
      loungeList: [],
      faqList: [],
      list: [],
      fadeIn: false,
      fadeOut: false,
      isShow: true,
      isShowAll: false,
      isActive: false
    };
  },
  components: {
    Header,
    Footer
  },
  mounted() {
    if (sessionStorage.getItem("isShow") === "true") {
      this.isShow = false;
    } else {
      this.fadeIn = true;
    }
    // 获取Token
    if (!localStorage.getItem("flag")) {
      localStorage.setItem("flag", "flag-his");
    }
    if (
      !localStorage.getItem("pass") ||
      localStorage.getItem("pass") === "undefined"
    ) {
      this.$axios
        .post(
          "/api/auxiliary/getToken",
          {},
          {
            headers: {
              language: this.$i18n.locale,
              flag: localStorage.getItem("flag")
            }
          }
        )
        .then(res => {
          localStorage.setItem("pass", res.data.data);
          this.request();
        })
        .catch(err => {});
    } else {
      this.request();
    }
  },
  methods: {
    request() {
      //获取价格
      this.$axios
        .post(
          "/api/auxiliary/getCurrencyPrice",
          {
            currencyType: this.$store.state.currency
          },
          {
            headers: {
              language: this.$i18n.locale,
              token: localStorage.getItem("pass")
            }
          }
        )
        .then(res => {
          if (res.data.state === "11") {
            this.$store.commit("setPrice", res.data.data);
            this.$store.commit("resetTotalPrice", res.data.data);
          }
        })
        .catch(err => {});

      // 获取问答列表数据
      this.$axios
        .post(
          "/api/auxiliary/getFAQs",
          {},
          {
            headers: {
              language: this.$i18n.locale,
              token: localStorage.getItem("pass")
            }
          }
        )
        .then(res => {
          if (res.data.state === "11") {
            this.faqList = res.data.data;
          }
        })
        .catch(err => {});

      // 获取服务条款数据
      this.$axios
        .post(
          "/api/auxiliary/getTsAndCs",
          {},
          {
            headers: {
              language: this.$i18n.locale,
              token: localStorage.getItem("pass")
            }
          }
        )
        .then(res => {
          if (res.data.state === "11") {
            this.list = res.data.data;
          }
        })
        .catch(err => {});

      // 获取休息室列表数据
      this.$axios
        .post(
          "/api/lounge/loungeList",
          {},
          {
            headers: {
              language: this.$i18n.locale,
              token: localStorage.getItem("pass")
            }
          }
        )
        .then(res => {
          if (res.data.state === "11") {
            this.loungeList = res.data.data;
          }
        })
        .catch(err => {});
    },
    hide() {
      this.fadeOut = true;
      sessionStorage.setItem("isShow", this.isShow);
    },
    increment() {
      this.$store.commit("increment");
    },
    decrement() {
      this.$store.commit("decrement");
    },
    ShowAll() {
      if (this.isShowAll === false) {
        this.isShowAll = true;
        this.isActive = true;
      } else {
        this.isShowAll = false;
        this.isActive = false;
      }
    },
    buy() {
      //意图购买数据统计请求
      this.$axios
        .post(
          "/api/auxiliary/intentionPurchase",
          {},
          {
            headers: {
              language: this.$i18n.locale,
              token: localStorage.getItem("pass")
            }
          }
        )
        .then(res => {
          this.$router.push({ path: "/detail" });
        });
    },
    toThousands(num) {
      var result = [],
        counter = 0;
      num = (num || 0).toString().split("");
      for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result.unshift(num[i]);
        if (!(counter % 3) && i != 0) {
          result.unshift(",");
        }
      }
      return result.join("");
    }
  },
  computed: {
    count() {
      return this.$store.state.count;
    },
    currency() {
      return this.$store.state.currency;
    },
    totalPrice() {
      return this.toThousands(this.$store.state.totalPrice);
    },
    termList() {
      if (this.isShowAll === false) {
        var termList = [];
        if (this.list.length > 6) {
          for (var i = 0; i < 6; i++) {
            termList.push(this.list[i]);
          }
        } else {
          termList = this.list;
        }
        return termList;
      } else {
        return this.list;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.animation {
  width: 100%;
  height: 78px;
  position: fixed;
  background: #fff;
  z-index: 10;
}
.inClass {
  animation: fadeIn 1s ease;
  bottom: 0;
}
.outClass {
  animation: fadeOut 1s ease;
  bottom: -120px;
}
@keyframes fadeIn {
  from {
    bottom: -120px;
  }
  to {
    bottom: 0;
  }
}
@keyframes fadeOut {
  from {
    bottom: 0;
  }
  to {
    bottom: -120px;
  }
}
.animation-inner {
  width: 80%;
  margin: 19px auto;
  position: relative;
}
.animation .close-btn {
  width: 48px;
  height: 48px;
  position: absolute;
  right: -10px;
  top: -44px;
}
.animation-inner .tip {
  float: left;
  width: 62%;
  font-size: 12px;
  line-height: 20px;
}
.animation-inner .btns {
  float: right;
  width: 30%;
}
.btns a {
  float: right;
  width: 123px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  border: 1px #910000 solid;
  border-radius: 4px;
  font-size: 14px;
}
.btns .accept-btn {
  background: #910000;
  margin-right: 10px;
  color: #fff;
}
.btns .readMore-btn {
  background: #fff;
  color: #910000;
}

.banner {
  width: 100%;
  height: 600px;
  position: relative;
  overflow: hidden;
}
.banner-bg {
  width: 100%;
  height: 100%;
}
.banner-bottom {
  width: 94%;
  background-color: rgba(0, 0, 0, 0.69);
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 0 3%;
}
.banner-bottom h1 {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  padding: 41px 0;
}
.banner-card {
  width: 213px;
  height: 127px;
  position: absolute;
  left: 15%;
  bottom: 95px;
  z-index: 2;
}

.buy-box {
  width: 80%;
  margin: 0 auto;
  height: 130px;
  background: #f5f6fa;
  padding: 0 10%;
}
.buy-box-left {
  width: 60%;
  float: left;
  overflow: hidden;
}
.buy-box-right {
  float: right;
  overflow: hidden;
}
.buy-box-l,
.buy-box-r {
  float: left;
}
.buy-box-left .buy-box-l {
  width: 60%;
  margin: 20px 0;
}
.buy-box-left .buy-box-l h2 {
  color: #333;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 5px;
}
.buy-box-left .buy-box-l ul {
  color: #7b8090;
  font-size: 14px;
}
.buy-box-left .buy-box-l ul li {
  position: relative;
}
.buy-box-left .buy-box-l ul li span {
  font-size: 30px;
  height: 19px;
  line-height: 14px;
  margin-right: 5px;
  position: absolute;
  left: 0;
  top: 0;
}
.buy-box-left .buy-box-l ul li p {
  padding-left: 15px;
}
.buy-box-left .buy-box-r {
  float: left;
  color: #910000;
  height: 50px;
  position: relative;
  margin: 40px 0 40px 40px;
}
.buy-box-left .buy-box-r span {
  float: left;
  height: 50px;
}
.buy-box-left .buy-box-r .currency {
  font-size: 22px;
  line-height: 58px;
}
.buy-box-left .buy-box-r .price {
  font-size: 28px;
  font-weight: bold;
  margin-left: 5px;
  line-height: 56px;
}
.buy-box-left .buy-box-r .per {
  font-size: 14px;
  color: #7b8090;
  padding-left: 10px;
  padding-top: 16px;
}
.buy-box-right .buy-box-l {
  width: 152px;
  margin: 45px 35px 45px 0;
}
.buy-box-right .buy-box-l span {
  float: left;
  margin-right: 5px;
  height: 38px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  font-size: 20px;
}
.buy-box-right .buy-box-l span:last-child {
  margin-right: 0;
}
.buy-box-right .buy-box-l span img {
  width: 100%;
  height: 100%;
}
.buy-box-right .buy-box-l .minus,
.buy-box-right .buy-box-l .plus {
  width: 40px;
  height: 40px;
  cursor: pointer;
}
.buy-box-right .buy-box-l .number {
  width: 60px;
  background: #fff;
  border: 1px #333333 solid;
}
.buy-box-right .buy-box-r {
  width: 150px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background: #910000;
  border-radius: 4px;
  cursor: pointer;
  margin: 40px 0;
}

.lounges-box {
  width: 90%;
  margin: 0 auto;
}
.lounges-list li {
  float: left;
  width: 32%;
  margin-right: 2%;
  margin-bottom: 2%;
}
.lounges-list li:nth-child(3n) {
  margin-right: 0;
}
.lounges-list li a {
  display: block;
}
.lounge-pic img {
  width: 100%;
  height: 100%;
}
.lounge-name {
  height: 42px;
  font-size: 16px;
  color: #333333;
  margin: 10px 0 5px;
}
.lounge-location {
  position: relative;
}
.lounge-location img {
  width: 18px;
  height: 24px;
  position: absolute;
  left: 0;
  top: 0;
}
.lounge-location div {
  font-size: 14px;
  color: #7b8090;
  padding-left: 24px;
}
.lounge-location div p {
  height: 20px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.lounge-btn {
  width: 400px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  background: #910000;
  border-radius: 4px;
  margin: 30px auto 60px;
  font-size: 20px;
  font-weight: bold;
}
.lounge-btn a {
  color: #fff;
  display: block;
}

.step-list {
  margin-bottom: 60px;
}
.step-list li {
  float: left;
  width: 33.33%;
  position: relative;
}
.arrow-right {
  width: 26px;
  height: 49px;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -24.5px;
}
.arrow-down {
  width: 38px;
  height: 20px;
  position: absolute;
  left: 50%;
  margin-left: -19px;
  bottom: -44px;
  display: none;
}
.step-list-title {
  font-size: 20px;
  font-weight: bold;
}
.step-list-title p {
  text-align: center;
}
.step-pic {
  width: 200px;
  height: 120px;
  margin: 0 auto;
}
.step-intr {
  width: 270px;
  margin: 0 auto;
  font-size: 14px;
  text-align: center;
  line-height: 24px;
}

.faqs-box {
  background: #ebecf1;
  overflow: hidden;
}
.faqs-list {
  width: 80%;
  font-size: 14px;
  margin: 0 auto;
  padding-bottom: 60px;
}
.faqs-list li {
  margin-bottom: 20px;
}
.faqs-list li p {
  line-height: 22px;
}
.faqs-list .q {
  color: #7b8090;
}
.faqs-list li:nth-child(5) {
  font-weight: bold;
}

.terms-list {
  width: 80%;
  margin: 0 auto;
}
.terms-list li {
  font-size: 14px;
  margin-bottom: 10px;
}
.show-more {
  width: 140px;
  height: 20px;
  line-height: 20px;
  position: relative;
  left: 50%;
  margin-left: -70px;
  margin-top: 60px;
  margin-bottom: 60px;
  font-size: 20px;
  cursor: pointer;
  color: #910000;
}
.show-more img {
  width: 23px;
  height: 12px;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -6px;
}
.show-more .active {
  transform: rotate(180deg);
}

.footer {
  height: 140px;
  position: relative;
  background: #333;
}
.footer-inner {
  width: 90%;
  margin: 0 auto;
  font-size: 14px;
  color: #fff;
}
.footer-inner-left {
  float: left;
  margin-top: 45px;
}
.footer-inner-left img {
  width: 168px;
}
.footer-inner-right {
  float: right;
  margin-top: 80px;
}

@media screen and (max-width: 1500px) {
  .buy-box {
    width: 90%;
    padding: 0 5%;
  }
  .buy-box-left .buy-box-l {
    margin: 10px 0;
  }
}

@media screen and (max-width: 1300px) {
  .buy-box {
    width: 96%;
    padding: 0 2%;
  }
  .buy-box-left .buy-box-r {
    margin: 40px 0 40px 20px;
  }
}

@media screen and (max-width: 1100px) {
  .btns .accept-btn {
    margin-right: 0;
  }
  .buy-box {
    height: 260px;
  }
  .buy-box-left,
  .buy-box-right,
  .buy-box-left .buy-box-l,
  .buy-box-left .buy-box-r {
    width: 100%;
  }
  .buy-box-left .buy-box-l ul {
    font-size: 12px;
  }
  .buy-box-left .buy-box-l {
    margin: 20px 0 10px;
  }
  .buy-box-left .buy-box-r {
    margin: 0;
  }
  .buy-box-right .buy-box-l {
    margin: 35px 35px 35px 0;
  }
  .buy-box-right .buy-box-r {
    margin: 30px 0;
  }
}

@media screen and (max-width: 940px) {
  .banner-bottom h1 {
    font-size: 24px;
  }
}

@media screen and (max-width: 807px) {
  .banner-card {
    bottom: 110px;
  }
}

@media screen and (max-width: 640px) {
  .animation {
    width: 100%;
    height: 126px;
    left: 0;
    margin-left: 0;
  }
  .inClass {
    animation: fadeIn 1s ease;
    bottom: 0;
  }
  .outClass {
    animation: fadeOut 1s ease;
    bottom: -200px;
  }
  @keyframes fadeIn {
    from {
      bottom: -200px;
    }
    to {
      bottom: 0;
    }
  }
  @keyframes fadeOut {
    from {
      bottom: 0;
    }
    to {
      bottom: -200px;
    }
  }
  .animation-inner {
    width: 90%;
  }
  .animation-inner .tip {
    line-height: 17px;
    width: 56%;
  }
  .animation-inner .btns {
    width: 38%;
  }
  .btns a {
    margin-bottom: 10px;
  }
  .footer {
    height: 100px;
  }
  .footer-inner-left {
    margin-top: 28px;
  }
  .footer-inner-left img {
    width: 140px;
  }
  .footer-inner-right {
    display: none;
  }
  .banner {
    height: 310px;
  }
  .banner-bottom h1 {
    font-size: 22px;
    height: 48px;
    padding: 28px 0;
    text-align: left;
  }
  .banner-card {
    width: 135px;
    height: 81px;
    bottom: 82px;
    left: 3%;
  }
  .lounges-box {
    width: 96%;
  }
  .lounges-list li:nth-child(3n) {
    margin-right: 2%;
  }
  .lounges-list li {
    width: 49%;
    margin-right: 2%;
  }
  .lounges-list li:nth-child(2n) {
    margin-right: 0;
  }
  .lounge-pic {
    height: 110px;
  }
  .lounge-name {
    height: 30px;
    font-size: 12px;
  }
  .lounge-location div {
    font-size: 8px;
    padding-left: 12px;
  }
  .lounge-location img {
    width: 8.8px;
    height: 11.5px;
    top: 4px;
  }
  .lounge-btn {
    width: 50%;
    height: 50px;
    line-height: 50px;
  }
  .step-box {
    margin-bottom: 0;
  }
  .step-list {
    margin: 0;
  }
  .step-list li {
    width: 100%;
    margin-bottom: 80px;
  }
  .arrow-right {
    display: none;
  }
  .arrow-down {
    display: block;
  }
  .show-more {
    width: 114px;
    margin-bottom: 50px;
    font-size: 16px;
  }
  .show-more img {
    width: 17.7px;
    height: 9.3px;
    margin-top: -5px;
  }
  .faqs-list {
    width: 90%;
  }
  .terms-list {
    width: 90%;
  }
}

@media screen and (max-width: 480px) {
  .banner-bottom h1 {
    font-size: 18px;
  }
  .buy-box-right .buy-box-l {
    margin: 15px 20px 15px 0;
  }
  .buy-box-right .buy-box-r {
    width: 120px;
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue